import type { ClientEnvironmentConfig } from '@core/config-models';
import { createAction, props } from '@ngrx/store';

export const configLoaded = createAction(
  '[Config] Config Loaded',
  props<{ config: ClientEnvironmentConfig }>()
);
